// src/services/api.js
import axios from 'axios'

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true // se você usa cookies HttpOnly
})

export default instance